import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ModalWrapper from './ModalWrapper'
import { BasicModalProps } from '../../types/modals'
import './TryItOutModal.css'
import './Modals.css'
import StoreButtons from '../Common/Buttons/StoreButtons'

const { Title, Paragraph } = Typography

export const TryItOutModal: React.FC<BasicModalProps> = ({
    isOpen,
    onClose,
}) => {
    const { t } = useTranslation()

    return (
        <ModalWrapper isOpen={isOpen} onClose={onClose} width={862}>
            <div data-testid="try-it-modal" className="modal-content">
                <div className="tryitout-modal-container">
                    <div className="tryitout-modal-content">
                        <div className="text-container">
                            <Title className="title" level={2}>
                                {t('modals.tryItOut.title')}
                            </Title>
                            <Paragraph className="paragraph">
                                {t('modals.tryItOut.description')}
                            </Paragraph>
                            <div className="qr-store-buttons">
                                <div className="qr-code">
                                    <img
                                        src="/img/qrcode.webp"
                                        alt={t('common.alt.qrCode')}
                                    />
                                </div>
                                <StoreButtons main="store-buttons" />
                            </div>
                        </div>
                        <div className="image-group">
                            <div className="image">
                                <img
                                    className="image-top"
                                    src="/img/whatis-Volley.png"
                                    alt={t('common.alt.volleyball')}
                                />
                            </div>
                            <div className="image">
                                <img
                                    className="image-bottom"
                                    src="/img/whatis-Football.png"
                                    alt={t('common.alt.football')}
                                />
                            </div>
                        </div>
                        <div className="single-mobile-image">
                            <img
                                src="/img/football-card.png"
                                alt={t('common.alt.mobileView')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    )
}
